import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, messageErreur } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ChoixListe } from "./ChoixListe";

const Statut = ({ s, types, editable, onMaj }) => {
  const enr = (d) => api.post("/statuts-appel", { code: s.code, ...d }).then(onMaj).catch((e) => toast.error(messageErreur(e)));
  return (
    <div className="at-card p-3 space-y-2" data-testid={`call-status-row-${s.code}`}>
      <div className="flex items-center gap-2">
        <input type="color" disabled={!editable} defaultValue={s.couleur} onBlur={(e) => e.target.value !== s.couleur && enr({ couleur: e.target.value.toUpperCase() })} className="w-11 h-11 at-pill shrink-0 border-0 bg-transparent" data-testid={`call-status-color-${s.code}`} />
        <input disabled={!editable} defaultValue={s.nom} onBlur={(e) => e.target.value.trim() && e.target.value !== s.nom && enr({ nom: e.target.value })} className="at-input" data-testid={`call-status-name-${s.code}`} />
      </div>
      <p className="text-xs at-muted">{types[s.type]}</p>
      {s.type === "final" && (
        <div className="grid grid-cols-2 gap-2 items-center">
          <label className="block"><span className="at-label block mb-1">Repos (jours)</span><input type="number" min="0" disabled={!editable} defaultValue={s.repos_jours ?? ""} placeholder="Jamais"
            onBlur={(e) => enr({ repos_jours: Number(e.target.value || 0) })} className="at-input" data-testid={`call-status-rest-${s.code}`} /></label>
          <label className="flex items-center gap-2 text-sm min-h-[44px]"><input type="checkbox" disabled={!editable} checked={Boolean(s.repos_nouvelle_operation)} onChange={(e) => enr({ repos_nouvelle_operation: e.target.checked })} data-testid={`call-status-op-${s.code}`} />Revient à une nouvelle opération</label>
        </div>
      )}
    </div>
  );
};

export default function Statuts() {
  const { user } = useAuth();
  const editable = user.role === "dirigeant";
  const [d, setD] = useState(null);
  const charger = useCallback(() => api.get("/statuts-appel").then((r) => setD(r.data)), []);
  useEffect(() => { charger(); }, [charger]);
  if (!d) return null;
  const relier = (ringover, crm) => api.put("/statuts-appel/ringover", { ringover, crm }).then(() => { toast.success("Correspondance enregistrée."); charger(); }).catch((e) => toast.error(messageErreur(e)));
  return (
    <div className="space-y-6">
      <section>
        <h2 className="text-base md:text-lg font-bold mb-3">Statuts d'appel</h2>
        <div className="grid md:grid-cols-2 gap-2" data-testid="call-status-list">{d.statuts.map((s) => <Statut key={`${s.code}-${s.couleur}-${s.nom}`} s={s} types={d.types} editable={editable} onMaj={charger} />)}</div>
      </section>
      <section>
        <h2 className="text-base md:text-lg font-bold mb-1">Correspondance avec Ringover</h2>
        <p className="text-sm at-muted mb-3">Chaque statut Ringover est relié à un statut du CRM (simulation jusqu'au lot 7).</p>
        <div className="space-y-2" data-testid="ringover-map">
          {d.ringover.map((r, i) => (
            <div key={r.ringover} className="grid grid-cols-2 gap-2 items-center" data-testid={`ringover-row-${i}`}>
              <p className="text-sm font-semibold break-words">{r.ringover}</p>
              <ChoixListe valeur={r.crm} onChange={(v) => editable && relier(r.ringover, v)} options={d.statuts.map((s) => ({ code: s.code, label: s.nom }))} testId={`ringover-select-${i}`} />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
